/* eslint-disable */
import type { LocalizableString } from "../cash/localization/localization.pb";
import type { Color } from "../cash/ui/Color.pb";
import type { UiControl } from "./ui/control.pb";

/** CardModule represents an abstract container on the card tab */
export interface CardModule {
  hero_issued_card?: CardModuleHeroIssuedCardModule | undefined;
  hero_null_state?: CardModuleHeroNullStateModule | undefined;
  bubble?: CardModuleBubbleModule | undefined;
  list?: CardModuleListModule | undefined;
  gift_cards?: CardModuleGiftCardsModule | undefined;
}

/** HeroIssuedCardModule represents a container for the single card at the top of the card tab */
export interface CardModuleHeroIssuedCardModule {
  element?: IssuedCardElement;
}

/** HeroNullStateModule represents a container for the single card at the top of the card tab in null state */
export interface CardModuleHeroNullStateModule {
  element?: CardModuleElement;
}

/** BubbleModule represents a container for a single element, shown as a bubble */
export interface CardModuleBubbleModule {
  element?: CardModuleElement;
}

/** ListModule represents a container for a list of elements. */
export interface CardModuleListModule {
  elements?: CardModuleElement[];
}

export interface CardModuleGiftCardsModule {
  element?: CardModuleElement;
}

export interface IssuedCardElement {
  /** card token */
  card_identifier?: string;
  primary_control?: CardModuleElement;
  overflow_controls?: CardModuleElement[];
}

export interface SelectBoostElement {
  /** boost identifier */
  boost_identifier?: string;
  /** Upsell button text for adding a boost */
  upsell_button_text?: string;
  /** Upsell text describing boost functionality */
  upsell_description?: string;
}

export interface RoundUpsElement {
  icon?: RoundUpsElementIcon;
  /** Main text (eg. "Round Ups") */
  main_text?: string;
  localizable_main_text?: LocalizableString;
  /** Automation info (eg. "Off" or company name etc) */
  info_text?: string;
  localizable_info_text?: LocalizableString;
  info_text_color?: Color;
  info_text_background_color?: Color;
  accessibility_text?: string;
  localizable_accessibility_text?: LocalizableString;
  info_text_font?: RoundUpsElementFont;
  /** Tags out of order. Next: 12 */
  client_route?: string;
}

export enum RoundUpsElementIcon {
  ROUND_ARROW_UP = "ROUND_ARROW_UP",
}

export enum RoundUpsElementFont {
  MEDIUM = "MEDIUM",
  SMALL = "SMALL",
}

export interface CardModuleElement {
  ui_control?: UiControl | undefined;
  selected_boost_element?: SelectBoostElement | undefined;
  round_ups_element?: RoundUpsElement | undefined;
}
